import api from '../api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'

export const usePostFlexiGroupAddMember = (
  successCallBack: (data: any) => void,
  errorCallBack: (data: any) => void,
) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({flexiGroupId, memberId}: {flexiGroupId: string, memberId: any}) =>
      api.patch(ApiRouteEnum.FLEXI_ADD_MEMBER , {
        user: memberId,
        flexiGroup: parseInt(flexiGroupId)
      }),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries([ApiRouteEnum.USER])
        queryClient.invalidateQueries([ApiRouteEnum.ORGANIZATION])
        successCallBack(data.data)
      },
      onError: (error) => errorCallBack(error),
    },
  )
}
